import { render } from "./MainHero.vue?vue&type=template&id=59ae09d8"
import script from "./MainHero.vue?vue&type=script&lang=js"
export * from "./MainHero.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__